export const wcpmLookupTable = [
    {
        "WCPM": 0,
        "Lexile": -180,
        "DIBELS_gr1": 26,
        "DIBELS_gr2": 1,
        "DIBELS_gr3": 0,
        "DRA": 1,
        "Guided_Reading_Level": "A"
    },
    {
        "WCPM": 1,
        "Lexile": -175,
        "DIBELS_gr1": 27,
        "DIBELS_gr2": 1,
        "DIBELS_gr3": 0,
        "DRA": 1,
        "Guided_Reading_Level": "A"
    },
    {
        "WCPM": 2,
        "Lexile": -165,
        "DIBELS_gr1": 28,
        "DIBELS_gr2": 3,
        "DIBELS_gr3": 1,
        "DRA": 2,
        "Guided_Reading_Level": "B"
    },
    {
        "WCPM": 3,
        "Lexile": -160,
        "DIBELS_gr1": 28,
        "DIBELS_gr2": 3,
        "DIBELS_gr3": 1,
        "DRA": 2,
        "Guided_Reading_Level": "B"
    },
    {
        "WCPM": 4,
        "Lexile": -150,
        "DIBELS_gr1": 30,
        "DIBELS_gr2": 5,
        "DIBELS_gr3": 3,
        "DRA": 3,
        "Guided_Reading_Level": "C"
    },
    {
        "WCPM": 5,
        "Lexile": -145,
        "DIBELS_gr1": 30,
        "DIBELS_gr2": 6,
        "DIBELS_gr3": 3,
        "DRA": 3,
        "Guided_Reading_Level": "C"
    },
    {
        "WCPM": 6,
        "Lexile": -140,
        "DIBELS_gr1": 31,
        "DIBELS_gr2": 6,
        "DIBELS_gr3": 4,
        "DRA": 3,
        "Guided_Reading_Level": "C"
    },
    {
        "WCPM": 7,
        "Lexile": -130,
        "DIBELS_gr1": 32,
        "DIBELS_gr2": 8,
        "DIBELS_gr3": 6,
        "DRA": 4,
        "Guided_Reading_Level": "C"
    },
    {
        "WCPM": 8,
        "Lexile": -125,
        "DIBELS_gr1": 33,
        "DIBELS_gr2": 8,
        "DIBELS_gr3": 6,
        "DRA": 4,
        "Guided_Reading_Level": "C"
    },
    {
        "WCPM": 9,
        "Lexile": -115,
        "DIBELS_gr1": 34,
        "DIBELS_gr2": 10,
        "DIBELS_gr3": 8,
        "DRA": 4,
        "Guided_Reading_Level": "C"
    },
    {
        "WCPM": 10,
        "Lexile": -110,
        "DIBELS_gr1": 34,
        "DIBELS_gr2": 10,
        "DIBELS_gr3": 8,
        "DRA": 4,
        "Guided_Reading_Level": "C"
    },
    {
        "WCPM": 11,
        "Lexile": -105,
        "DIBELS_gr1": 35,
        "DIBELS_gr2": 11,
        "DIBELS_gr3": 9,
        "DRA": 4,
        "Guided_Reading_Level": "C"
    },
    {
        "WCPM": 12,
        "Lexile": -95,
        "DIBELS_gr1": 36,
        "DIBELS_gr2": 12,
        "DIBELS_gr3": 10,
        "DRA": 4,
        "Guided_Reading_Level": "C"
    },
    {
        "WCPM": 13,
        "Lexile": -90,
        "DIBELS_gr1": 37,
        "DIBELS_gr2": 13,
        "DIBELS_gr3": 11,
        "DRA": 4,
        "Guided_Reading_Level": "C"
    },
    {
        "WCPM": 14,
        "Lexile": -80,
        "DIBELS_gr1": 38,
        "DIBELS_gr2": 14,
        "DIBELS_gr3": 12,
        "DRA": 4,
        "Guided_Reading_Level": "D"
    },
    {
        "WCPM": 15,
        "Lexile": -75,
        "DIBELS_gr1": 38,
        "DIBELS_gr2": 15,
        "DIBELS_gr3": 13,
        "DRA": 4,
        "Guided_Reading_Level": "D"
    },
    {
        "WCPM": 16,
        "Lexile": -70,
        "DIBELS_gr1": 39,
        "DIBELS_gr2": 16,
        "DIBELS_gr3": 14,
        "DRA": 6,
        "Guided_Reading_Level": "D"
    },
    {
        "WCPM": 17,
        "Lexile": -60,
        "DIBELS_gr1": 40,
        "DIBELS_gr2": 17,
        "DIBELS_gr3": 15,
        "DRA": 6,
        "Guided_Reading_Level": "D"
    },
    {
        "WCPM": 18,
        "Lexile": -55,
        "DIBELS_gr1": 41,
        "DIBELS_gr2": 18,
        "DIBELS_gr3": 16,
        "DRA": 6,
        "Guided_Reading_Level": "D"
    },
    {
        "WCPM": 19,
        "Lexile": -45,
        "DIBELS_gr1": 42,
        "DIBELS_gr2": 19,
        "DIBELS_gr3": 17,
        "DRA": 6,
        "Guided_Reading_Level": "D"
    },
    {
        "WCPM": 20,
        "Lexile": -40,
        "DIBELS_gr1": 42,
        "DIBELS_gr2": 20,
        "DIBELS_gr3": 18,
        "DRA": 6,
        "Guided_Reading_Level": "E"
    },
    {
        "WCPM": 21,
        "Lexile": -35,
        "DIBELS_gr1": 43,
        "DIBELS_gr2": 21,
        "DIBELS_gr3": 19,
        "DRA": 6,
        "Guided_Reading_Level": "E"
    },
    {
        "WCPM": 22,
        "Lexile": -25,
        "DIBELS_gr1": 44,
        "DIBELS_gr2": 22,
        "DIBELS_gr3": 20,
        "DRA": 8,
        "Guided_Reading_Level": "E"
    },
    {
        "WCPM": 23,
        "Lexile": -20,
        "DIBELS_gr1": 45,
        "DIBELS_gr2": 23,
        "DIBELS_gr3": 21,
        "DRA": 8,
        "Guided_Reading_Level": "E"
    },
    {
        "WCPM": 24,
        "Lexile": -10,
        "DIBELS_gr1": 46,
        "DIBELS_gr2": 24,
        "DIBELS_gr3": 22,
        "DRA": 8,
        "Guided_Reading_Level": "E"
    },
    {
        "WCPM": 25,
        "Lexile": -5,
        "DIBELS_gr1": 47,
        "DIBELS_gr2": 25,
        "DIBELS_gr3": 23,
        "DRA": 8,
        "Guided_Reading_Level": "E"
    },
    {
        "WCPM": 26,
        "Lexile": 0,
        "DIBELS_gr1": 47,
        "DIBELS_gr2": 25,
        "DIBELS_gr3": 23,
        "DRA": 8,
        "Guided_Reading_Level": "E"
    },
    {
        "WCPM": 27,
        "Lexile": 10,
        "DIBELS_gr1": 48,
        "DIBELS_gr2": 27,
        "DIBELS_gr3": 25,
        "DRA": 8,
        "Guided_Reading_Level": "F"
    },
    {
        "WCPM": 28,
        "Lexile": 15,
        "DIBELS_gr1": 49,
        "DIBELS_gr2": 27,
        "DIBELS_gr3": 25,
        "DRA": 8,
        "Guided_Reading_Level": "F"
    },
    {
        "WCPM": 29,
        "Lexile": 25,
        "DIBELS_gr1": 50,
        "DIBELS_gr2": 29,
        "DIBELS_gr3": 27,
        "DRA": 10,
        "Guided_Reading_Level": "F"
    },
    {
        "WCPM": 30,
        "Lexile": 30,
        "DIBELS_gr1": 51,
        "DIBELS_gr2": 29,
        "DIBELS_gr3": 27,
        "DRA": 10,
        "Guided_Reading_Level": "F"
    },
    {
        "WCPM": 31,
        "Lexile": 35,
        "DIBELS_gr1": 51,
        "DIBELS_gr2": 30,
        "DIBELS_gr3": 28,
        "DRA": 10,
        "Guided_Reading_Level": "F"
    },
    {
        "WCPM": 32,
        "Lexile": 45,
        "DIBELS_gr1": 52,
        "DIBELS_gr2": 31,
        "DIBELS_gr3": 29,
        "DRA": 10,
        "Guided_Reading_Level": "F"
    },
    {
        "WCPM": 33,
        "Lexile": 50,
        "DIBELS_gr1": 53,
        "DIBELS_gr2": 32,
        "DIBELS_gr3": 30,
        "DRA": 10,
        "Guided_Reading_Level": "F"
    },
    {
        "WCPM": 34,
        "Lexile": 60,
        "DIBELS_gr1": 54,
        "DIBELS_gr2": 34,
        "DIBELS_gr3": 32,
        "DRA": 10,
        "Guided_Reading_Level": "G"
    },
    {
        "WCPM": 35,
        "Lexile": 65,
        "DIBELS_gr1": 55,
        "DIBELS_gr2": 34,
        "DIBELS_gr3": 32,
        "DRA": 10,
        "Guided_Reading_Level": "G"
    },
    {
        "WCPM": 36,
        "Lexile": 70,
        "DIBELS_gr1": 55,
        "DIBELS_gr2": 35,
        "DIBELS_gr3": 33,
        "DRA": 12,
        "Guided_Reading_Level": "G"
    },
    {
        "WCPM": 37,
        "Lexile": 80,
        "DIBELS_gr1": 56,
        "DIBELS_gr2": 36,
        "DIBELS_gr3": 34,
        "DRA": 12,
        "Guided_Reading_Level": "G"
    },
    {
        "WCPM": 38,
        "Lexile": 85,
        "DIBELS_gr1": 57,
        "DIBELS_gr2": 37,
        "DIBELS_gr3": 35,
        "DRA": 12,
        "Guided_Reading_Level": "G"
    },
    {
        "WCPM": 39,
        "Lexile": 95,
        "DIBELS_gr1": 58,
        "DIBELS_gr2": 38,
        "DIBELS_gr3": 36,
        "DRA": 12,
        "Guided_Reading_Level": "G"
    },
    {
        "WCPM": 40,
        "Lexile": 100,
        "DIBELS_gr1": 59,
        "DIBELS_gr2": 39,
        "DIBELS_gr3": 37,
        "DRA": 12,
        "Guided_Reading_Level": "H"
    },
    {
        "WCPM": 41,
        "Lexile": 105,
        "DIBELS_gr1": 59,
        "DIBELS_gr2": 40,
        "DIBELS_gr3": 38,
        "DRA": 12,
        "Guided_Reading_Level": "H"
    },
    {
        "WCPM": 42,
        "Lexile": 115,
        "DIBELS_gr1": 61,
        "DIBELS_gr2": 41,
        "DIBELS_gr3": 39,
        "DRA": 14,
        "Guided_Reading_Level": "H"
    },
    {
        "WCPM": 43,
        "Lexile": 120,
        "DIBELS_gr1": 61,
        "DIBELS_gr2": 42,
        "DIBELS_gr3": 40,
        "DRA": 14,
        "Guided_Reading_Level": "H"
    },
    {
        "WCPM": 44,
        "Lexile": 130,
        "DIBELS_gr1": 62,
        "DIBELS_gr2": 43,
        "DIBELS_gr3": 41,
        "DRA": 14,
        "Guided_Reading_Level": "H"
    },
    {
        "WCPM": 45,
        "Lexile": 135,
        "DIBELS_gr1": 63,
        "DIBELS_gr2": 44,
        "DIBELS_gr3": 42,
        "DRA": 14,
        "Guided_Reading_Level": "H"
    },
    {
        "WCPM": 46,
        "Lexile": 140,
        "DIBELS_gr1": 63,
        "DIBELS_gr2": 44,
        "DIBELS_gr3": 43,
        "DRA": 14,
        "Guided_Reading_Level": "H"
    },
    {
        "WCPM": 47,
        "Lexile": 150,
        "DIBELS_gr1": 65,
        "DIBELS_gr2": 46,
        "DIBELS_gr3": 44,
        "DRA": 14,
        "Guided_Reading_Level": "I"
    },
    {
        "WCPM": 48,
        "Lexile": 155,
        "DIBELS_gr1": 65,
        "DIBELS_gr2": 47,
        "DIBELS_gr3": 45,
        "DRA": 14,
        "Guided_Reading_Level": "I"
    },
    {
        "WCPM": 49,
        "Lexile": 165,
        "DIBELS_gr1": 66,
        "DIBELS_gr2": 48,
        "DIBELS_gr3": 46,
        "DRA": 16,
        "Guided_Reading_Level": "I"
    },
    {
        "WCPM": 50,
        "Lexile": 170,
        "DIBELS_gr1": 67,
        "DIBELS_gr2": 49,
        "DIBELS_gr3": 47,
        "DRA": 16,
        "Guided_Reading_Level": "J"
    },
    {
        "WCPM": 51,
        "Lexile": 175,
        "DIBELS_gr1": 67,
        "DIBELS_gr2": 49,
        "DIBELS_gr3": 47,
        "DRA": 16,
        "Guided_Reading_Level": "J"
    },
    {
        "WCPM": 52,
        "Lexile": 185,
        "DIBELS_gr1": 69,
        "DIBELS_gr2": 51,
        "DIBELS_gr3": 49,
        "DRA": 16,
        "Guided_Reading_Level": "J"
    },
    {
        "WCPM": 53,
        "Lexile": 190,
        "DIBELS_gr1": 69,
        "DIBELS_gr2": 51,
        "DIBELS_gr3": 49,
        "DRA": 16,
        "Guided_Reading_Level": "J"
    },
    {
        "WCPM": 54,
        "Lexile": 200,
        "DIBELS_gr1": 70,
        "DIBELS_gr2": 53,
        "DIBELS_gr3": 51,
        "DRA": 16,
        "Guided_Reading_Level": "K"
    },
    {
        "WCPM": 55,
        "Lexile": 205,
        "DIBELS_gr1": 71,
        "DIBELS_gr2": 53,
        "DIBELS_gr3": 51,
        "DRA": 16,
        "Guided_Reading_Level": "K"
    },
    {
        "WCPM": 56,
        "Lexile": 210,
        "DIBELS_gr1": 72,
        "DIBELS_gr2": 54,
        "DIBELS_gr3": 52,
        "DRA": 18,
        "Guided_Reading_Level": "K"
    },
    {
        "WCPM": 57,
        "Lexile": 220,
        "DIBELS_gr1": 73,
        "DIBELS_gr2": 55,
        "DIBELS_gr3": 53,
        "DRA": 18,
        "Guided_Reading_Level": "K"
    },
    {
        "WCPM": 58,
        "Lexile": 225,
        "DIBELS_gr1": 73,
        "DIBELS_gr2": 56,
        "DIBELS_gr3": 54,
        "DRA": 18,
        "Guided_Reading_Level": "K"
    },
    {
        "WCPM": 59,
        "Lexile": 235,
        "DIBELS_gr1": 74,
        "DIBELS_gr2": 57,
        "DIBELS_gr3": 56,
        "DRA": 18,
        "Guided_Reading_Level": "K"
    },
    {
        "WCPM": 60,
        "Lexile": 240,
        "DIBELS_gr1": 75,
        "DIBELS_gr2": 58,
        "DIBELS_gr3": 56,
        "DRA": 18,
        "Guided_Reading_Level": "L"
    },
    {
        "WCPM": 61,
        "Lexile": 245,
        "DIBELS_gr1": 76,
        "DIBELS_gr2": 59,
        "DIBELS_gr3": 57,
        "DRA": 18,
        "Guided_Reading_Level": "L"
    },
    {
        "WCPM": 62,
        "Lexile": 255,
        "DIBELS_gr1": 77,
        "DIBELS_gr2": 60,
        "DIBELS_gr3": 58,
        "DRA": 20,
        "Guided_Reading_Level": "L"
    },
    {
        "WCPM": 63,
        "Lexile": 260,
        "DIBELS_gr1": 77,
        "DIBELS_gr2": 61,
        "DIBELS_gr3": 59,
        "DRA": 20,
        "Guided_Reading_Level": "L"
    },
    {
        "WCPM": 64,
        "Lexile": 270,
        "DIBELS_gr1": 79,
        "DIBELS_gr2": 62,
        "DIBELS_gr3": 60,
        "DRA": 20,
        "Guided_Reading_Level": "L"
    },
    {
        "WCPM": 65,
        "Lexile": 275,
        "DIBELS_gr1": 79,
        "DIBELS_gr2": 63,
        "DIBELS_gr3": 61,
        "DRA": 20,
        "Guided_Reading_Level": "L"
    },
    {
        "WCPM": 66,
        "Lexile": 280,
        "DIBELS_gr1": 80,
        "DIBELS_gr2": 64,
        "DIBELS_gr3": 62,
        "DRA": 20,
        "Guided_Reading_Level": "L"
    },
    {
        "WCPM": 67,
        "Lexile": 290,
        "DIBELS_gr1": 81,
        "DIBELS_gr2": 65,
        "DIBELS_gr3": 63,
        "DRA": 20,
        "Guided_Reading_Level": "L"
    },
    {
        "WCPM": 68,
        "Lexile": 295,
        "DIBELS_gr1": 81,
        "DIBELS_gr2": 66,
        "DIBELS_gr3": 64,
        "DRA": 20,
        "Guided_Reading_Level": "L"
    },
    {
        "WCPM": 69,
        "Lexile": 305,
        "DIBELS_gr1": 83,
        "DIBELS_gr2": 67,
        "DIBELS_gr3": 65,
        "DRA": 22,
        "Guided_Reading_Level": "L"
    },
    {
        "WCPM": 70,
        "Lexile": 310,
        "DIBELS_gr1": 83,
        "DIBELS_gr2": 68,
        "DIBELS_gr3": 66,
        "DRA": 22,
        "Guided_Reading_Level": "L"
    },
    {
        "WCPM": 71,
        "Lexile": 315,
        "DIBELS_gr1": 84,
        "DIBELS_gr2": 68,
        "DIBELS_gr3": 66,
        "DRA": 22,
        "Guided_Reading_Level": "L"
    },
    {
        "WCPM": 72,
        "Lexile": 325,
        "DIBELS_gr1": 85,
        "DIBELS_gr2": 70,
        "DIBELS_gr3": 68,
        "DRA": 22,
        "Guided_Reading_Level": "L"
    },
    {
        "WCPM": 73,
        "Lexile": 330,
        "DIBELS_gr1": 86,
        "DIBELS_gr2": 70,
        "DIBELS_gr3": 69,
        "DRA": 22,
        "Guided_Reading_Level": "L"
    },
    {
        "WCPM": 74,
        "Lexile": 340,
        "DIBELS_gr1": 87,
        "DIBELS_gr2": 72,
        "DIBELS_gr3": 70,
        "DRA": 22,
        "Guided_Reading_Level": "L"
    },
    {
        "WCPM": 75,
        "Lexile": 345,
        "DIBELS_gr1": 87,
        "DIBELS_gr2": 72,
        "DIBELS_gr3": 71,
        "DRA": 22,
        "Guided_Reading_Level": "L"
    },
    {
        "WCPM": 76,
        "Lexile": 350,
        "DIBELS_gr1": 88,
        "DIBELS_gr2": 73,
        "DIBELS_gr3": 71,
        "DRA": 24,
        "Guided_Reading_Level": "L"
    },
    {
        "WCPM": 77,
        "Lexile": 360,
        "DIBELS_gr1": 89,
        "DIBELS_gr2": 75,
        "DIBELS_gr3": 73,
        "DRA": 24,
        "Guided_Reading_Level": "M"
    },
    {
        "WCPM": 78,
        "Lexile": 365,
        "DIBELS_gr1": 90,
        "DIBELS_gr2": 75,
        "DIBELS_gr3": 73,
        "DRA": 24,
        "Guided_Reading_Level": "M"
    },
    {
        "WCPM": 79,
        "Lexile": 375,
        "DIBELS_gr1": 91,
        "DIBELS_gr2": 77,
        "DIBELS_gr3": 75,
        "DRA": 24,
        "Guided_Reading_Level": "M"
    },
    {
        "WCPM": 80,
        "Lexile": 380,
        "DIBELS_gr1": 91,
        "DIBELS_gr2": 77,
        "DIBELS_gr3": 75,
        "DRA": 24,
        "Guided_Reading_Level": "M"
    },
    {
        "WCPM": 81,
        "Lexile": 385,
        "DIBELS_gr1": 92,
        "DIBELS_gr2": 78,
        "DIBELS_gr3": 76,
        "DRA": 24,
        "Guided_Reading_Level": "M"
    },
    {
        "WCPM": 82,
        "Lexile": 395,
        "DIBELS_gr1": 93,
        "DIBELS_gr2": 79,
        "DIBELS_gr3": 77,
        "DRA": 26,
        "Guided_Reading_Level": "M"
    },
    {
        "WCPM": 83,
        "Lexile": 400,
        "DIBELS_gr1": 94,
        "DIBELS_gr2": 80,
        "DIBELS_gr3": 78,
        "DRA": 26,
        "Guided_Reading_Level": "M"
    },
    {
        "WCPM": 84,
        "Lexile": 410,
        "DIBELS_gr1": 95,
        "DIBELS_gr2": 81,
        "DIBELS_gr3": 79,
        "DRA": 26,
        "Guided_Reading_Level": "M"
    },
    {
        "WCPM": 85,
        "Lexile": 415,
        "DIBELS_gr1": 95,
        "DIBELS_gr2": 82,
        "DIBELS_gr3": 80,
        "DRA": 26,
        "Guided_Reading_Level": "M"
    },
    {
        "WCPM": 86,
        "Lexile": 420,
        "DIBELS_gr1": 96,
        "DIBELS_gr2": 83,
        "DIBELS_gr3": 81,
        "DRA": 26,
        "Guided_Reading_Level": "M"
    },
    {
        "WCPM": 87,
        "Lexile": 430,
        "DIBELS_gr1": 97,
        "DIBELS_gr2": 84,
        "DIBELS_gr3": 82,
        "DRA": 26,
        "Guided_Reading_Level": "N"
    },
    {
        "WCPM": 88,
        "Lexile": 435,
        "DIBELS_gr1": 98,
        "DIBELS_gr2": 85,
        "DIBELS_gr3": 83,
        "DRA": 26,
        "Guided_Reading_Level": "N"
    },
    {
        "WCPM": 89,
        "Lexile": 445,
        "DIBELS_gr1": 99,
        "DIBELS_gr2": 86,
        "DIBELS_gr3": 84,
        "DRA": 28,
        "Guided_Reading_Level": "N"
    },
    {
        "WCPM": 90,
        "Lexile": 450,
        "DIBELS_gr1": 100,
        "DIBELS_gr2": 87,
        "DIBELS_gr3": 85,
        "DRA": 28,
        "Guided_Reading_Level": "N"
    },
    {
        "WCPM": 91,
        "Lexile": 455,
        "DIBELS_gr1": 100,
        "DIBELS_gr2": 88,
        "DIBELS_gr3": 86,
        "DRA": 28,
        "Guided_Reading_Level": "N"
    },
    {
        "WCPM": 92,
        "Lexile": 465,
        "DIBELS_gr1": 101,
        "DIBELS_gr2": 89,
        "DIBELS_gr3": 87,
        "DRA": 28,
        "Guided_Reading_Level": "N"
    },
    {
        "WCPM": 93,
        "Lexile": 470,
        "DIBELS_gr1": 102,
        "DIBELS_gr2": 90,
        "DIBELS_gr3": 88,
        "DRA": 28,
        "Guided_Reading_Level": "N"
    },
    {
        "WCPM": 94,
        "Lexile": 480,
        "DIBELS_gr1": 103,
        "DIBELS_gr2": 91,
        "DIBELS_gr3": 89,
        "DRA": 28,
        "Guided_Reading_Level": "N"
    },
    {
        "WCPM": 95,
        "Lexile": 485,
        "DIBELS_gr1": 104,
        "DIBELS_gr2": 92,
        "DIBELS_gr3": 90,
        "DRA": 28,
        "Guided_Reading_Level": "N"
    },
    {
        "WCPM": 96,
        "Lexile": 490,
        "DIBELS_gr1": 104,
        "DIBELS_gr2": 92,
        "DIBELS_gr3": 90,
        "DRA": 30,
        "Guided_Reading_Level": "N"
    },
    {
        "WCPM": 97,
        "Lexile": 500,
        "DIBELS_gr1": 105,
        "DIBELS_gr2": 94,
        "DIBELS_gr3": 92,
        "DRA": 30,
        "Guided_Reading_Level": "N"
    },
    {
        "WCPM": 98,
        "Lexile": 505,
        "DIBELS_gr1": 106,
        "DIBELS_gr2": 94,
        "DIBELS_gr3": 93,
        "DRA": 30,
        "Guided_Reading_Level": "N"
    },
    {
        "WCPM": 99,
        "Lexile": 515,
        "DIBELS_gr1": 107,
        "DIBELS_gr2": 96,
        "DIBELS_gr3": 94,
        "DRA": 30,
        "Guided_Reading_Level": "N"
    },
    {
        "WCPM": 100,
        "Lexile": 520,
        "DIBELS_gr1": 108,
        "DIBELS_gr2": 96,
        "DIBELS_gr3": 95,
        "DRA": 30,
        "Guided_Reading_Level": "N"
    },
    {
        "WCPM": 101,
        "Lexile": 525,
        "DIBELS_gr1": 108,
        "DIBELS_gr2": 97,
        "DIBELS_gr3": 95,
        "DRA": 30,
        "Guided_Reading_Level": "N"
    },
    {
        "WCPM": 102,
        "Lexile": 535,
        "DIBELS_gr1": 109,
        "DIBELS_gr2": 98,
        "DIBELS_gr3": 97,
        "DRA": 32,
        "Guided_Reading_Level": "N"
    },
    {
        "WCPM": 103,
        "Lexile": 540,
        "DIBELS_gr1": 110,
        "DIBELS_gr2": 99,
        "DIBELS_gr3": 97,
        "DRA": 32,
        "Guided_Reading_Level": "N"
    },
    {
        "WCPM": 104,
        "Lexile": 550,
        "DIBELS_gr1": 111,
        "DIBELS_gr2": 100,
        "DIBELS_gr3": 99,
        "DRA": 32,
        "Guided_Reading_Level": "N"
    },
    {
        "WCPM": 105,
        "Lexile": 555,
        "DIBELS_gr1": 112,
        "DIBELS_gr2": 101,
        "DIBELS_gr3": 99,
        "DRA": 32,
        "Guided_Reading_Level": "N"
    },
    {
        "WCPM": 106,
        "Lexile": 560,
        "DIBELS_gr1": 112,
        "DIBELS_gr2": 102,
        "DIBELS_gr3": 100,
        "DRA": 32,
        "Guided_Reading_Level": "N"
    },
    {
        "WCPM": 107,
        "Lexile": 570,
        "DIBELS_gr1": 114,
        "DIBELS_gr2": 103,
        "DIBELS_gr3": 101,
        "DRA": 32,
        "Guided_Reading_Level": "O"
    },
    {
        "WCPM": 108,
        "Lexile": 575,
        "DIBELS_gr1": 114,
        "DIBELS_gr2": 104,
        "DIBELS_gr3": 102,
        "DRA": 32,
        "Guided_Reading_Level": "O"
    },
    {
        "WCPM": 109,
        "Lexile": 585,
        "DIBELS_gr1": 115,
        "DIBELS_gr2": 105,
        "DIBELS_gr3": 103,
        "DRA": 34,
        "Guided_Reading_Level": "O"
    },
    {
        "WCPM": 110,
        "Lexile": 590,
        "DIBELS_gr1": 116,
        "DIBELS_gr2": 106,
        "DIBELS_gr3": 104,
        "DRA": 34,
        "Guided_Reading_Level": "O"
    },
    {
        "WCPM": 111,
        "Lexile": 595,
        "DIBELS_gr1": 116,
        "DIBELS_gr2": 107,
        "DIBELS_gr3": 105,
        "DRA": 34,
        "Guided_Reading_Level": "O"
    },
    {
        "WCPM": 112,
        "Lexile": 605,
        "DIBELS_gr1": 118,
        "DIBELS_gr2": 108,
        "DIBELS_gr3": 106,
        "DRA": 34,
        "Guided_Reading_Level": "O"
    },
    {
        "WCPM": 113,
        "Lexile": 610,
        "DIBELS_gr1": 118,
        "DIBELS_gr2": 109,
        "DIBELS_gr3": 107,
        "DRA": 34,
        "Guided_Reading_Level": "O"
    },
    {
        "WCPM": 114,
        "Lexile": 620,
        "DIBELS_gr1": 119,
        "DIBELS_gr2": 110,
        "DIBELS_gr3": 108,
        "DRA": 34,
        "Guided_Reading_Level": "O"
    },
    {
        "WCPM": 115,
        "Lexile": 625,
        "DIBELS_gr1": 120,
        "DIBELS_gr2": 111,
        "DIBELS_gr3": 109,
        "DRA": 34,
        "Guided_Reading_Level": "O"
    },
    {
        "WCPM": 116,
        "Lexile": 630,
        "DIBELS_gr1": 121,
        "DIBELS_gr2": 111,
        "DIBELS_gr3": 110,
        "DRA": 36,
        "Guided_Reading_Level": "O"
    },
    {
        "WCPM": 117,
        "Lexile": 640,
        "DIBELS_gr1": 122,
        "DIBELS_gr2": 113,
        "DIBELS_gr3": 111,
        "DRA": 36,
        "Guided_Reading_Level": "P"
    },
    {
        "WCPM": 118,
        "Lexile": 645,
        "DIBELS_gr1": 122,
        "DIBELS_gr2": 113,
        "DIBELS_gr3": 112,
        "DRA": 36,
        "Guided_Reading_Level": "P"
    },
    {
        "WCPM": 119,
        "Lexile": 655,
        "DIBELS_gr1": 123,
        "DIBELS_gr2": 115,
        "DIBELS_gr3": 113,
        "DRA": 36,
        "Guided_Reading_Level": "P"
    },
    {
        "WCPM": 120,
        "Lexile": 660,
        "DIBELS_gr1": 124,
        "DIBELS_gr2": 116,
        "DIBELS_gr3": 114,
        "DRA": 36,
        "Guided_Reading_Level": "P"
    },
    {
        "WCPM": 121,
        "Lexile": 665,
        "DIBELS_gr1": 125,
        "DIBELS_gr2": 116,
        "DIBELS_gr3": 114,
        "DRA": 36,
        "Guided_Reading_Level": "P"
    },
    {
        "WCPM": 122,
        "Lexile": 675,
        "DIBELS_gr1": 126,
        "DIBELS_gr2": 118,
        "DIBELS_gr3": 116,
        "DRA": 38,
        "Guided_Reading_Level": "P"
    },
    {
        "WCPM": 123,
        "Lexile": 680,
        "DIBELS_gr1": 126,
        "DIBELS_gr2": 118,
        "DIBELS_gr3": 116,
        "DRA": 38,
        "Guided_Reading_Level": "P"
    },
    {
        "WCPM": 124,
        "Lexile": 690,
        "DIBELS_gr1": 128,
        "DIBELS_gr2": 120,
        "DIBELS_gr3": 118,
        "DRA": 38,
        "Guided_Reading_Level": "P"
    },
    {
        "WCPM": 125,
        "Lexile": 695,
        "DIBELS_gr1": 128,
        "DIBELS_gr2": 120,
        "DIBELS_gr3": 119,
        "DRA": 38,
        "Guided_Reading_Level": "P"
    },
    {
        "WCPM": 126,
        "Lexile": 700,
        "DIBELS_gr1": 129,
        "DIBELS_gr2": 121,
        "DIBELS_gr3": 119,
        "DRA": 38,
        "Guided_Reading_Level": "P"
    },
    {
        "WCPM": 127,
        "Lexile": 710,
        "DIBELS_gr1": 130,
        "DIBELS_gr2": 122,
        "DIBELS_gr3": 121,
        "DRA": 38,
        "Guided_Reading_Level": "Q"
    },
    {
        "WCPM": 128,
        "Lexile": 715,
        "DIBELS_gr1": 130,
        "DIBELS_gr2": 123,
        "DIBELS_gr3": 121,
        "DRA": 38,
        "Guided_Reading_Level": "Q"
    },
    {
        "WCPM": 129,
        "Lexile": 725,
        "DIBELS_gr1": 132,
        "DIBELS_gr2": 124,
        "DIBELS_gr3": 123,
        "DRA": 40,
        "Guided_Reading_Level": "Q"
    },
    {
        "WCPM": 130,
        "Lexile": 730,
        "DIBELS_gr1": 132,
        "DIBELS_gr2": 125,
        "DIBELS_gr3": 123,
        "DRA": 40,
        "Guided_Reading_Level": "S"
    },
    {
        "WCPM": 131,
        "Lexile": 735,
        "DIBELS_gr1": 133,
        "DIBELS_gr2": 126,
        "DIBELS_gr3": 124,
        "DRA": 40,
        "Guided_Reading_Level": "S"
    },
    {
        "WCPM": 132,
        "Lexile": 745,
        "DIBELS_gr1": 134,
        "DIBELS_gr2": 127,
        "DIBELS_gr3": 125,
        "DRA": 40,
        "Guided_Reading_Level": "S"
    },
    {
        "WCPM": 133,
        "Lexile": 750,
        "DIBELS_gr1": 135,
        "DIBELS_gr2": 128,
        "DIBELS_gr3": 126,
        "DRA": 40,
        "Guided_Reading_Level": "S"
    },
    {
        "WCPM": 134,
        "Lexile": 760,
        "DIBELS_gr1": 136,
        "DIBELS_gr2": 129,
        "DIBELS_gr3": 127,
        "DRA": 40,
        "Guided_Reading_Level": "S"
    },
    {
        "WCPM": 135,
        "Lexile": 765,
        "DIBELS_gr1": 136,
        "DIBELS_gr2": 130,
        "DIBELS_gr3": 128,
        "DRA": 40,
        "Guided_Reading_Level": "S"
    },
    {
        "WCPM": 136,
        "Lexile": 770,
        "DIBELS_gr1": 137,
        "DIBELS_gr2": 131,
        "DIBELS_gr3": 129,
        "DRA": 42,
        "Guided_Reading_Level": "S"
    },
    {
        "WCPM": 137,
        "Lexile": 780,
        "DIBELS_gr1": 138,
        "DIBELS_gr2": 132,
        "DIBELS_gr3": 130,
        "DRA": 42,
        "Guided_Reading_Level": "S"
    },
    {
        "WCPM": 138,
        "Lexile": 785,
        "DIBELS_gr1": 139,
        "DIBELS_gr2": 133,
        "DIBELS_gr3": 131,
        "DRA": 42,
        "Guided_Reading_Level": "S"
    },
    {
        "WCPM": 139,
        "Lexile": 795,
        "DIBELS_gr1": 140,
        "DIBELS_gr2": 134,
        "DIBELS_gr3": 132,
        "DRA": 42,
        "Guided_Reading_Level": "S"
    },
    {
        "WCPM": 140,
        "Lexile": 800,
        "DIBELS_gr1": 140,
        "DIBELS_gr2": 135,
        "DIBELS_gr3": 133,
        "DRA": 42,
        "Guided_Reading_Level": "S"
    },
    {
        "WCPM": 141,
        "Lexile": 805,
        "DIBELS_gr1": 141,
        "DIBELS_gr2": 135,
        "DIBELS_gr3": 134,
        "DRA": 42,
        "Guided_Reading_Level": "S"
    },
    {
        "WCPM": 142,
        "Lexile": 815,
        "DIBELS_gr1": 142,
        "DIBELS_gr2": 137,
        "DIBELS_gr3": 135,
        "DRA": 44,
        "Guided_Reading_Level": "S"
    },
    {
        "WCPM": 143,
        "Lexile": 820,
        "DIBELS_gr1": 143,
        "DIBELS_gr2": 137,
        "DIBELS_gr3": 136,
        "DRA": 44,
        "Guided_Reading_Level": "S"
    },
    {
        "WCPM": 144,
        "Lexile": 830,
        "DIBELS_gr1": 144,
        "DIBELS_gr2": 139,
        "DIBELS_gr3": 137,
        "DRA": 44,
        "Guided_Reading_Level": "S"
    },
    {
        "WCPM": 145,
        "Lexile": 835,
        "DIBELS_gr1": 144,
        "DIBELS_gr2": 139,
        "DIBELS_gr3": 138,
        "DRA": 44,
        "Guided_Reading_Level": "S"
    },
    {
        "WCPM": 146,
        "Lexile": 840,
        "DIBELS_gr1": 145,
        "DIBELS_gr2": 140,
        "DIBELS_gr3": 138,
        "DRA": 44,
        "Guided_Reading_Level": "S"
    },
    {
        "WCPM": 147,
        "Lexile": 850,
        "DIBELS_gr1": 146,
        "DIBELS_gr2": 141,
        "DIBELS_gr3": 140,
        "DRA": 44,
        "Guided_Reading_Level": "T"
    },
    {
        "WCPM": 148,
        "Lexile": 855,
        "DIBELS_gr1": 147,
        "DIBELS_gr2": 142,
        "DIBELS_gr3": 140,
        "DRA": 44,
        "Guided_Reading_Level": "T"
    },
    {
        "WCPM": 149,
        "Lexile": 865,
        "DIBELS_gr1": 148,
        "DIBELS_gr2": 144,
        "DIBELS_gr3": 142,
        "DRA": 46,
        "Guided_Reading_Level": "T"
    },
    {
        "WCPM": 150,
        "Lexile": 870,
        "DIBELS_gr1": 148,
        "DIBELS_gr2": 144,
        "DIBELS_gr3": 143,
        "DRA": 46,
        "Guided_Reading_Level": "T"
    },
    {
        "WCPM": 151,
        "Lexile": 875,
        "DIBELS_gr1": 149,
        "DIBELS_gr2": 145,
        "DIBELS_gr3": 143,
        "DRA": 46,
        "Guided_Reading_Level": "T"
    },
    {
        "WCPM": 152,
        "Lexile": 885,
        "DIBELS_gr1": 150,
        "DIBELS_gr2": 146,
        "DIBELS_gr3": 145,
        "DRA": 46,
        "Guided_Reading_Level": "T"
    },
    {
        "WCPM": 153,
        "Lexile": 890,
        "DIBELS_gr1": 151,
        "DIBELS_gr2": 147,
        "DIBELS_gr3": 145,
        "DRA": 46,
        "Guided_Reading_Level": "T"
    },
    {
        "WCPM": 154,
        "Lexile": 900,
        "DIBELS_gr1": 152,
        "DIBELS_gr2": 148,
        "DIBELS_gr3": 147,
        "DRA": 46,
        "Guided_Reading_Level": "T"
    },
    {
        "WCPM": 155,
        "Lexile": 905,
        "DIBELS_gr1": 153,
        "DIBELS_gr2": 149,
        "DIBELS_gr3": 147,
        "DRA": 46,
        "Guided_Reading_Level": "T"
    },
    {
        "WCPM": 156,
        "Lexile": 910,
        "DIBELS_gr1": 153,
        "DIBELS_gr2": 150,
        "DIBELS_gr3": 148,
        "DRA": 48,
        "Guided_Reading_Level": "T"
    },
    {
        "WCPM": 157,
        "Lexile": 920,
        "DIBELS_gr1": 154,
        "DIBELS_gr2": 151,
        "DIBELS_gr3": 149,
        "DRA": 48,
        "Guided_Reading_Level": "T"
    },
    {
        "WCPM": 158,
        "Lexile": 925,
        "DIBELS_gr1": 155,
        "DIBELS_gr2": 152,
        "DIBELS_gr3": 150,
        "DRA": 48,
        "Guided_Reading_Level": "T"
    },
    {
        "WCPM": 159,
        "Lexile": 935,
        "DIBELS_gr1": 156,
        "DIBELS_gr2": 153,
        "DIBELS_gr3": 151,
        "DRA": 48,
        "Guided_Reading_Level": "T"
    },
    {
        "WCPM": 160,
        "Lexile": 940,
        "DIBELS_gr1": 157,
        "DIBELS_gr2": 154,
        "DIBELS_gr3": 152,
        "DRA": 48,
        "Guided_Reading_Level": "T"
    },
    {
        "WCPM": 161,
        "Lexile": 945,
        "DIBELS_gr1": 157,
        "DIBELS_gr2": 154,
        "DIBELS_gr3": 153,
        "DRA": 48,
        "Guided_Reading_Level": "T"
    },
    {
        "WCPM": 162,
        "Lexile": 955,
        "DIBELS_gr1": 158,
        "DIBELS_gr2": 156,
        "DIBELS_gr3": 154,
        "DRA": 50,
        "Guided_Reading_Level": "T"
    },
    {
        "WCPM": 163,
        "Lexile": 960,
        "DIBELS_gr1": 159,
        "DIBELS_gr2": 156,
        "DIBELS_gr3": 155,
        "DRA": 50,
        "Guided_Reading_Level": "T"
    },
    {
        "WCPM": 164,
        "Lexile": 970,
        "DIBELS_gr1": 160,
        "DIBELS_gr2": 158,
        "DIBELS_gr3": 156,
        "DRA": 50,
        "Guided_Reading_Level": "U"
    },
    {
        "WCPM": 165,
        "Lexile": 975,
        "DIBELS_gr1": 161,
        "DIBELS_gr2": 159,
        "DIBELS_gr3": 157,
        "DRA": 50,
        "Guided_Reading_Level": "U"
    },
    {
        "WCPM": 166,
        "Lexile": 980,
        "DIBELS_gr1": 161,
        "DIBELS_gr2": 159,
        "DIBELS_gr3": 158,
        "DRA": 50,
        "Guided_Reading_Level": "U"
    },
    {
        "WCPM": 167,
        "Lexile": 990,
        "DIBELS_gr1": 162,
        "DIBELS_gr2": 161,
        "DIBELS_gr3": 159,
        "DRA": 50,
        "Guided_Reading_Level": "U"
    },
    {
        "WCPM": 168,
        "Lexile": 995,
        "DIBELS_gr1": 163,
        "DIBELS_gr2": 161,
        "DIBELS_gr3": 160,
        "DRA": 50,
        "Guided_Reading_Level": "U"
    },
    {
        "WCPM": 169,
        "Lexile": 1005,
        "DIBELS_gr1": 164,
        "DIBELS_gr2": 163,
        "DIBELS_gr3": 161,
        "DRA": 52,
        "Guided_Reading_Level": "U"
    },
    {
        "WCPM": 170,
        "Lexile": 1010,
        "DIBELS_gr1": 165,
        "DIBELS_gr2": 163,
        "DIBELS_gr3": 162,
        "DRA": 52,
        "Guided_Reading_Level": "U"
    },
    {
        "WCPM": 171,
        "Lexile": 1015,
        "DIBELS_gr1": 165,
        "DIBELS_gr2": 164,
        "DIBELS_gr3": 162,
        "DRA": 52,
        "Guided_Reading_Level": "U"
    },
    {
        "WCPM": 172,
        "Lexile": 1025,
        "DIBELS_gr1": 167,
        "DIBELS_gr2": 165,
        "DIBELS_gr3": 164,
        "DRA": 52,
        "Guided_Reading_Level": "U"
    },
    {
        "WCPM": 173,
        "Lexile": 1030,
        "DIBELS_gr1": 167,
        "DIBELS_gr2": 166,
        "DIBELS_gr3": 164,
        "DRA": 52,
        "Guided_Reading_Level": "U"
    },
    {
        "WCPM": 174,
        "Lexile": 1040,
        "DIBELS_gr1": 168,
        "DIBELS_gr2": 167,
        "DIBELS_gr3": 166,
        "DRA": 52,
        "Guided_Reading_Level": "U"
    },
    {
        "WCPM": 175,
        "Lexile": 1045,
        "DIBELS_gr1": 169,
        "DIBELS_gr2": 168,
        "DIBELS_gr3": 166,
        "DRA": 52,
        "Guided_Reading_Level": "U"
    },
    {
        "WCPM": 176,
        "Lexile": 1050,
        "DIBELS_gr1": 169,
        "DIBELS_gr2": 169,
        "DIBELS_gr3": 167,
        "DRA": 54,
        "Guided_Reading_Level": "U"
    },
    {
        "WCPM": 177,
        "Lexile": 1060,
        "DIBELS_gr1": 171,
        "DIBELS_gr2": 170,
        "DIBELS_gr3": 169,
        "DRA": 54,
        "Guided_Reading_Level": "U"
    },
    {
        "WCPM": 178,
        "Lexile": 1065,
        "DIBELS_gr1": 171,
        "DIBELS_gr2": 171,
        "DIBELS_gr3": 169,
        "DRA": 54,
        "Guided_Reading_Level": "U"
    },
    {
        "WCPM": 179,
        "Lexile": 1075,
        "DIBELS_gr1": 172,
        "DIBELS_gr2": 172,
        "DIBELS_gr3": 171,
        "DRA": 54,
        "Guided_Reading_Level": "U"
    },
    {
        "WCPM": 180,
        "Lexile": 1080,
        "DIBELS_gr1": 173,
        "DIBELS_gr2": 173,
        "DIBELS_gr3": 171,
        "DRA": 54,
        "Guided_Reading_Level": "V"
    },
    {
        "WCPM": 181,
        "Lexile": 1085,
        "DIBELS_gr1": 174,
        "DIBELS_gr2": 174,
        "DIBELS_gr3": 172,
        "DRA": 54,
        "Guided_Reading_Level": "V"
    },
    {
        "WCPM": 182,
        "Lexile": 1095,
        "DIBELS_gr1": 175,
        "DIBELS_gr2": 175,
        "DIBELS_gr3": 173,
        "DRA": 56,
        "Guided_Reading_Level": "V"
    },
    {
        "WCPM": 183,
        "Lexile": 1100,
        "DIBELS_gr1": 175,
        "DIBELS_gr2": 176,
        "DIBELS_gr3": 174,
        "DRA": 56,
        "Guided_Reading_Level": "V"
    },
    {
        "WCPM": 184,
        "Lexile": 1110,
        "DIBELS_gr1": 176,
        "DIBELS_gr2": 177,
        "DIBELS_gr3": 175,
        "DRA": 56,
        "Guided_Reading_Level": "V"
    },
    {
        "WCPM": 185,
        "Lexile": 1115,
        "DIBELS_gr1": 177,
        "DIBELS_gr2": 178,
        "DIBELS_gr3": 176,
        "DRA": 56,
        "Guided_Reading_Level": "V"
    },
    {
        "WCPM": 186,
        "Lexile": 1120,
        "DIBELS_gr1": 178,
        "DIBELS_gr2": 178,
        "DIBELS_gr3": 177,
        "DRA": 56,
        "Guided_Reading_Level": "V"
    },
    {
        "WCPM": 187,
        "Lexile": 1130,
        "DIBELS_gr1": 179,
        "DIBELS_gr2": 180,
        "DIBELS_gr3": 178,
        "DRA": 56,
        "Guided_Reading_Level": "V"
    },
    {
        "WCPM": 188,
        "Lexile": 1135,
        "DIBELS_gr1": 179,
        "DIBELS_gr2": 180,
        "DIBELS_gr3": 179,
        "DRA": 56,
        "Guided_Reading_Level": "V"
    },
    {
        "WCPM": 189,
        "Lexile": 1145,
        "DIBELS_gr1": 181,
        "DIBELS_gr2": 182,
        "DIBELS_gr3": 180,
        "DRA": 58,
        "Guided_Reading_Level": "V"
    },
    {
        "WCPM": 190,
        "Lexile": 1150,
        "DIBELS_gr1": 181,
        "DIBELS_gr2": 182,
        "DIBELS_gr3": 181,
        "DRA": 58,
        "Guided_Reading_Level": "V"
    },
    {
        "WCPM": 191,
        "Lexile": 1155,
        "DIBELS_gr1": 182,
        "DIBELS_gr2": 183,
        "DIBELS_gr3": 182,
        "DRA": 58,
        "Guided_Reading_Level": "V"
    },
    {
        "WCPM": 192,
        "Lexile": 1165,
        "DIBELS_gr1": 183,
        "DIBELS_gr2": 184,
        "DIBELS_gr3": 183,
        "DRA": 58,
        "Guided_Reading_Level": "V"
    },
    {
        "WCPM": 193,
        "Lexile": 1170,
        "DIBELS_gr1": 183,
        "DIBELS_gr2": 185,
        "DIBELS_gr3": 184,
        "DRA": 58,
        "Guided_Reading_Level": "V"
    },
    {
        "WCPM": 194,
        "Lexile": 1180,
        "DIBELS_gr1": 185,
        "DIBELS_gr2": 187,
        "DIBELS_gr3": 185,
        "DRA": 58,
        "Guided_Reading_Level": "W"
    },
    {
        "WCPM": 195,
        "Lexile": 1185,
        "DIBELS_gr1": 185,
        "DIBELS_gr2": 187,
        "DIBELS_gr3": 186,
        "DRA": 58,
        "Guided_Reading_Level": "W"
    },
    {
        "WCPM": 196,
        "Lexile": 1190,
        "DIBELS_gr1": 186,
        "DIBELS_gr2": 188,
        "DIBELS_gr3": 186,
        "DRA": 60,
        "Guided_Reading_Level": "W"
    },
    {
        "WCPM": 197,
        "Lexile": 1200,
        "DIBELS_gr1": 187,
        "DIBELS_gr2": 189,
        "DIBELS_gr3": 188,
        "DRA": 60,
        "Guided_Reading_Level": "X"
    },
    {
        "WCPM": 198,
        "Lexile": 1205,
        "DIBELS_gr1": 188,
        "DIBELS_gr2": 190,
        "DIBELS_gr3": 188,
        "DRA": 60,
        "Guided_Reading_Level": "X"
    },
    {
        "WCPM": 199,
        "Lexile": 1215,
        "DIBELS_gr1": 189,
        "DIBELS_gr2": 191,
        "DIBELS_gr3": 190,
        "DRA": 60,
        "Guided_Reading_Level": "X"
    },
    {
        "WCPM": 200,
        "Lexile": 1220,
        "DIBELS_gr1": 189,
        "DIBELS_gr2": 192,
        "DIBELS_gr3": 190,
        "DRA": 60,
        "Guided_Reading_Level": "X"
    },
    {
        "WCPM": 201,
        "Lexile": 1225,
        "DIBELS_gr1": 190,
        "DIBELS_gr2": 193,
        "DIBELS_gr3": 191,
        "DRA": 60,
        "Guided_Reading_Level": "X"
    },
    {
        "WCPM": 202,
        "Lexile": 1235,
        "DIBELS_gr1": 191,
        "DIBELS_gr2": 194,
        "DIBELS_gr3": 193,
        "DRA": 62,
        "Guided_Reading_Level": "X"
    },
    {
        "WCPM": 203,
        "Lexile": 1240,
        "DIBELS_gr1": 192,
        "DIBELS_gr2": 195,
        "DIBELS_gr3": 193,
        "DRA": 62,
        "Guided_Reading_Level": "X"
    },
    {
        "WCPM": 204,
        "Lexile": 1250,
        "DIBELS_gr1": 193,
        "DIBELS_gr2": 196,
        "DIBELS_gr3": 195,
        "DRA": 62,
        "Guided_Reading_Level": "X"
    },
    {
        "WCPM": 205,
        "Lexile": 1255,
        "DIBELS_gr1": 193,
        "DIBELS_gr2": 197,
        "DIBELS_gr3": 195,
        "DRA": 62,
        "Guided_Reading_Level": "X"
    },
    {
        "WCPM": 206,
        "Lexile": 1260,
        "DIBELS_gr1": 194,
        "DIBELS_gr2": 197,
        "DIBELS_gr3": 196,
        "DRA": 62,
        "Guided_Reading_Level": "X"
    },
    {
        "WCPM": 207,
        "Lexile": 1270,
        "DIBELS_gr1": 195,
        "DIBELS_gr2": 199,
        "DIBELS_gr3": 197,
        "DRA": 62,
        "Guided_Reading_Level": "X"
    },
    {
        "WCPM": 208,
        "Lexile": 1275,
        "DIBELS_gr1": 196,
        "DIBELS_gr2": 200,
        "DIBELS_gr3": 198,
        "DRA": 62,
        "Guided_Reading_Level": "X"
    },
    {
        "WCPM": 209,
        "Lexile": 1285,
        "DIBELS_gr1": 197,
        "DIBELS_gr2": 201,
        "DIBELS_gr3": 199,
        "DRA": 64,
        "Guided_Reading_Level": "X"
    },
    {
        "WCPM": 210,
        "Lexile": 1290,
        "DIBELS_gr1": 197,
        "DIBELS_gr2": 202,
        "DIBELS_gr3": 200,
        "DRA": 64,
        "Guided_Reading_Level": "Y"
    },
    {
        "WCPM": 211,
        "Lexile": 1295,
        "DIBELS_gr1": 198,
        "DIBELS_gr2": 202,
        "DIBELS_gr3": 201,
        "DRA": 64,
        "Guided_Reading_Level": "Y"
    },
    {
        "WCPM": 212,
        "Lexile": 1305,
        "DIBELS_gr1": 199,
        "DIBELS_gr2": 204,
        "DIBELS_gr3": 202,
        "DRA": 64,
        "Guided_Reading_Level": "Y"
    },
    {
        "WCPM": 213,
        "Lexile": 1310,
        "DIBELS_gr1": 200,
        "DIBELS_gr2": 204,
        "DIBELS_gr3": 203,
        "DRA": 64,
        "Guided_Reading_Level": "Y"
    },
    {
        "WCPM": 214,
        "Lexile": 1320,
        "DIBELS_gr1": 201,
        "DIBELS_gr2": 206,
        "DIBELS_gr3": 204,
        "DRA": 64,
        "Guided_Reading_Level": "Y"
    },
    {
        "WCPM": 215,
        "Lexile": 1325,
        "DIBELS_gr1": 202,
        "DIBELS_gr2": 206,
        "DIBELS_gr3": 205,
        "DRA": 64,
        "Guided_Reading_Level": "Y"
    },
    {
        "WCPM": 216,
        "Lexile": 1330,
        "DIBELS_gr1": 202,
        "DIBELS_gr2": 207,
        "DIBELS_gr3": 206,
        "DRA": 66,
        "Guided_Reading_Level": "Y"
    },
    {
        "WCPM": 217,
        "Lexile": 1340,
        "DIBELS_gr1": 203,
        "DIBELS_gr2": 208,
        "DIBELS_gr3": 207,
        "DRA": 66,
        "Guided_Reading_Level": "Y"
    },
    {
        "WCPM": 218,
        "Lexile": 1345,
        "DIBELS_gr1": 204,
        "DIBELS_gr2": 209,
        "DIBELS_gr3": 208,
        "DRA": 66,
        "Guided_Reading_Level": "Y"
    },
    {
        "WCPM": 219,
        "Lexile": 1355,
        "DIBELS_gr1": 205,
        "DIBELS_gr2": 210,
        "DIBELS_gr3": 209,
        "DRA": 66,
        "Guided_Reading_Level": "Y"
    },
    {
        "WCPM": 220,
        "Lexile": 1360,
        "DIBELS_gr1": 206,
        "DIBELS_gr2": 211,
        "DIBELS_gr3": 210,
        "DRA": 66,
        "Guided_Reading_Level": "Y"
    },
    {
        "WCPM": 221,
        "Lexile": 1365,
        "DIBELS_gr1": 206,
        "DIBELS_gr2": 212,
        "DIBELS_gr3": 210,
        "DRA": 66,
        "Guided_Reading_Level": "Y"
    },
    {
        "WCPM": 222,
        "Lexile": 1375,
        "DIBELS_gr1": 207,
        "DIBELS_gr2": 213,
        "DIBELS_gr3": 212,
        "DRA": 68,
        "Guided_Reading_Level": "Y"
    },
    {
        "WCPM": 223,
        "Lexile": 1380,
        "DIBELS_gr1": 208,
        "DIBELS_gr2": 214,
        "DIBELS_gr3": 212,
        "DRA": 68,
        "Guided_Reading_Level": "Y"
    },
    {
        "WCPM": 224,
        "Lexile": 1390,
        "DIBELS_gr1": 209,
        "DIBELS_gr2": 215,
        "DIBELS_gr3": 214,
        "DRA": 68,
        "Guided_Reading_Level": "Y"
    },
    {
        "WCPM": 225,
        "Lexile": 1395,
        "DIBELS_gr1": 210,
        "DIBELS_gr2": 216,
        "DIBELS_gr3": 214,
        "DRA": 68,
        "Guided_Reading_Level": "Y"
    },
    {
        "WCPM": 226,
        "Lexile": 1400,
        "DIBELS_gr1": 210,
        "DIBELS_gr2": 217,
        "DIBELS_gr3": 215,
        "DRA": 68,
        "Guided_Reading_Level": "Y"
    },
    {
        "WCPM": 227,
        "Lexile": 1410,
        "DIBELS_gr1": 211,
        "DIBELS_gr2": 218,
        "DIBELS_gr3": 216,
        "DRA": 68,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 228,
        "Lexile": 1415,
        "DIBELS_gr1": 212,
        "DIBELS_gr2": 219,
        "DIBELS_gr3": 217,
        "DRA": 68,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 229,
        "Lexile": 1425,
        "DIBELS_gr1": 213,
        "DIBELS_gr2": 220,
        "DIBELS_gr3": 219,
        "DRA": 70,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 230,
        "Lexile": 1430,
        "DIBELS_gr1": 214,
        "DIBELS_gr2": 221,
        "DIBELS_gr3": 219,
        "DRA": 70,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 231,
        "Lexile": 1435,
        "DIBELS_gr1": 214,
        "DIBELS_gr2": 221,
        "DIBELS_gr3": 220,
        "DRA": 70,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 232,
        "Lexile": 1445,
        "DIBELS_gr1": 216,
        "DIBELS_gr2": 223,
        "DIBELS_gr3": 221,
        "DRA": 70,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 233,
        "Lexile": 1450,
        "DIBELS_gr1": 216,
        "DIBELS_gr2": 223,
        "DIBELS_gr3": 222,
        "DRA": 70,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 234,
        "Lexile": 1460,
        "DIBELS_gr1": 217,
        "DIBELS_gr2": 225,
        "DIBELS_gr3": 223,
        "DRA": 70,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 235,
        "Lexile": 1465,
        "DIBELS_gr1": 218,
        "DIBELS_gr2": 225,
        "DIBELS_gr3": 224,
        "DRA": 70,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 236,
        "Lexile": 1470,
        "DIBELS_gr1": 218,
        "DIBELS_gr2": 226,
        "DIBELS_gr3": 225,
        "DRA": 72,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 237,
        "Lexile": 1480,
        "DIBELS_gr1": 220,
        "DIBELS_gr2": 228,
        "DIBELS_gr3": 226,
        "DRA": 72,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 238,
        "Lexile": 1485,
        "DIBELS_gr1": 220,
        "DIBELS_gr2": 228,
        "DIBELS_gr3": 227,
        "DRA": 72,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 239,
        "Lexile": 1495,
        "DIBELS_gr1": 221,
        "DIBELS_gr2": 230,
        "DIBELS_gr3": 228,
        "DRA": 72,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 240,
        "Lexile": 1500,
        "DIBELS_gr1": 222,
        "DIBELS_gr2": 230,
        "DIBELS_gr3": 229,
        "DRA": 72,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 241,
        "Lexile": 1505,
        "DIBELS_gr1": 223,
        "DIBELS_gr2": 231,
        "DIBELS_gr3": 229,
        "DRA": 72,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 242,
        "Lexile": 1515,
        "DIBELS_gr1": 224,
        "DIBELS_gr2": 232,
        "DIBELS_gr3": 231,
        "DRA": 74,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 243,
        "Lexile": 1520,
        "DIBELS_gr1": 224,
        "DIBELS_gr2": 233,
        "DIBELS_gr3": 232,
        "DRA": 74,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 244,
        "Lexile": 1530,
        "DIBELS_gr1": 225,
        "DIBELS_gr2": 234,
        "DIBELS_gr3": 233,
        "DRA": 74,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 245,
        "Lexile": 1535,
        "DIBELS_gr1": 226,
        "DIBELS_gr2": 235,
        "DIBELS_gr3": 234,
        "DRA": 74,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 246,
        "Lexile": 1540,
        "DIBELS_gr1": 227,
        "DIBELS_gr2": 236,
        "DIBELS_gr3": 234,
        "DRA": 74,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 247,
        "Lexile": 1550,
        "DIBELS_gr1": 228,
        "DIBELS_gr2": 237,
        "DIBELS_gr3": 236,
        "DRA": 74,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 248,
        "Lexile": 1555,
        "DIBELS_gr1": 228,
        "DIBELS_gr2": 238,
        "DIBELS_gr3": 236,
        "DRA": 74,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 249,
        "Lexile": 1565,
        "DIBELS_gr1": 229,
        "DIBELS_gr2": 239,
        "DIBELS_gr3": 238,
        "DRA": 76,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 250,
        "Lexile": 1570,
        "DIBELS_gr1": 230,
        "DIBELS_gr2": 240,
        "DIBELS_gr3": 238,
        "DRA": 76,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 251,
        "Lexile": 1575,
        "DIBELS_gr1": 231,
        "DIBELS_gr2": 241,
        "DIBELS_gr3": 239,
        "DRA": 76,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 252,
        "Lexile": 1585,
        "DIBELS_gr1": 232,
        "DIBELS_gr2": 242,
        "DIBELS_gr3": 240,
        "DRA": 76,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 253,
        "Lexile": 1590,
        "DIBELS_gr1": 232,
        "DIBELS_gr2": 243,
        "DIBELS_gr3": 241,
        "DRA": 76,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 254,
        "Lexile": 1600,
        "DIBELS_gr1": 234,
        "DIBELS_gr2": 244,
        "DIBELS_gr3": 243,
        "DRA": 76,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 255,
        "Lexile": 1605,
        "DIBELS_gr1": 234,
        "DIBELS_gr2": 245,
        "DIBELS_gr3": 243,
        "DRA": 76,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 256,
        "Lexile": 1610,
        "DIBELS_gr1": 235,
        "DIBELS_gr2": 245,
        "DIBELS_gr3": 244,
        "DRA": 78,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 257,
        "Lexile": 1620,
        "DIBELS_gr1": 236,
        "DIBELS_gr2": 247,
        "DIBELS_gr3": 245,
        "DRA": 78,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 258,
        "Lexile": 1625,
        "DIBELS_gr1": 236,
        "DIBELS_gr2": 247,
        "DIBELS_gr3": 246,
        "DRA": 78,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 259,
        "Lexile": 1635,
        "DIBELS_gr1": 238,
        "DIBELS_gr2": 249,
        "DIBELS_gr3": 247,
        "DRA": 78,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 260,
        "Lexile": 1640,
        "DIBELS_gr1": 238,
        "DIBELS_gr2": 249,
        "DIBELS_gr3": 248,
        "DRA": 78,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 261,
        "Lexile": 1645,
        "DIBELS_gr1": 239,
        "DIBELS_gr2": 250,
        "DIBELS_gr3": 249,
        "DRA": 78,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 262,
        "Lexile": 1655,
        "DIBELS_gr1": 240,
        "DIBELS_gr2": 251,
        "DIBELS_gr3": 250,
        "DRA": 80,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 263,
        "Lexile": 1660,
        "DIBELS_gr1": 241,
        "DIBELS_gr2": 252,
        "DIBELS_gr3": 251,
        "DRA": 80,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 264,
        "Lexile": 1670,
        "DIBELS_gr1": 242,
        "DIBELS_gr2": 253,
        "DIBELS_gr3": 252,
        "DRA": 80,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 265,
        "Lexile": 1675,
        "DIBELS_gr1": 242,
        "DIBELS_gr2": 254,
        "DIBELS_gr3": 253,
        "DRA": 80,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 266,
        "Lexile": 1680,
        "DIBELS_gr1": 243,
        "DIBELS_gr2": 255,
        "DIBELS_gr3": 253,
        "DRA": 80,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 267,
        "Lexile": 1690,
        "DIBELS_gr1": 244,
        "DIBELS_gr2": 256,
        "DIBELS_gr3": 255,
        "DRA": 80,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 268,
        "Lexile": 1695,
        "DIBELS_gr1": 245,
        "DIBELS_gr2": 257,
        "DIBELS_gr3": 256,
        "DRA": 80,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 269,
        "Lexile": 1705,
        "DIBELS_gr1": 246,
        "DIBELS_gr2": 258,
        "DIBELS_gr3": 257,
        "DRA": 80,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 270,
        "Lexile": 1710,
        "DIBELS_gr1": 246,
        "DIBELS_gr2": 259,
        "DIBELS_gr3": 258,
        "DRA": 80,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 271,
        "Lexile": 1715,
        "DIBELS_gr1": 247,
        "DIBELS_gr2": 260,
        "DIBELS_gr3": 258,
        "DRA": 80,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 272,
        "Lexile": 1725,
        "DIBELS_gr1": 248,
        "DIBELS_gr2": 261,
        "DIBELS_gr3": 260,
        "DRA": 80,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 273,
        "Lexile": 1730,
        "DIBELS_gr1": 249,
        "DIBELS_gr2": 262,
        "DIBELS_gr3": 260,
        "DRA": 80,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 274,
        "Lexile": 1740,
        "DIBELS_gr1": 250,
        "DIBELS_gr2": 263,
        "DIBELS_gr3": 262,
        "DRA": 80,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 275,
        "Lexile": 1745,
        "DIBELS_gr1": 250,
        "DIBELS_gr2": 264,
        "DIBELS_gr3": 262,
        "DRA": 80,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 276,
        "Lexile": 1750,
        "DIBELS_gr1": 251,
        "DIBELS_gr2": 264,
        "DIBELS_gr3": 263,
        "DRA": 80,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 277,
        "Lexile": 1760,
        "DIBELS_gr1": 252,
        "DIBELS_gr2": 266,
        "DIBELS_gr3": 264,
        "DRA": 80,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 278,
        "Lexile": 1765,
        "DIBELS_gr1": 253,
        "DIBELS_gr2": 266,
        "DIBELS_gr3": 265,
        "DRA": 80,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 279,
        "Lexile": 1775,
        "DIBELS_gr1": 254,
        "DIBELS_gr2": 268,
        "DIBELS_gr3": 266,
        "DRA": 80,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 280,
        "Lexile": 1780,
        "DIBELS_gr1": 255,
        "DIBELS_gr2": 269,
        "DIBELS_gr3": 267,
        "DRA": 80,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 281,
        "Lexile": 1785,
        "DIBELS_gr1": 255,
        "DIBELS_gr2": 269,
        "DIBELS_gr3": 268,
        "DRA": 80,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 282,
        "Lexile": 1795,
        "DIBELS_gr1": 256,
        "DIBELS_gr2": 271,
        "DIBELS_gr3": 269,
        "DRA": 80,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 283,
        "Lexile": 1800,
        "DIBELS_gr1": 257,
        "DIBELS_gr2": 271,
        "DIBELS_gr3": 270,
        "DRA": 80,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 284,
        "Lexile": 1810,
        "DIBELS_gr1": 258,
        "DIBELS_gr2": 273,
        "DIBELS_gr3": 271,
        "DRA": 80,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 285,
        "Lexile": 1815,
        "DIBELS_gr1": 259,
        "DIBELS_gr2": 273,
        "DIBELS_gr3": 272,
        "DRA": 80,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 286,
        "Lexile": 1820,
        "DIBELS_gr1": 259,
        "DIBELS_gr2": 274,
        "DIBELS_gr3": 273,
        "DRA": 80,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 287,
        "Lexile": 1830,
        "DIBELS_gr1": 260,
        "DIBELS_gr2": 275,
        "DIBELS_gr3": 274,
        "DRA": 80,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 288,
        "Lexile": 1835,
        "DIBELS_gr1": 261,
        "DIBELS_gr2": 276,
        "DIBELS_gr3": 275,
        "DRA": 80,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 289,
        "Lexile": 1845,
        "DIBELS_gr1": 262,
        "DIBELS_gr2": 277,
        "DIBELS_gr3": 276,
        "DRA": 80,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 290,
        "Lexile": 1850,
        "DIBELS_gr1": 263,
        "DIBELS_gr2": 278,
        "DIBELS_gr3": 277,
        "DRA": 80,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 291,
        "Lexile": 1855,
        "DIBELS_gr1": 263,
        "DIBELS_gr2": 279,
        "DIBELS_gr3": 277,
        "DRA": 80,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 292,
        "Lexile": 1865,
        "DIBELS_gr1": 264,
        "DIBELS_gr2": 280,
        "DIBELS_gr3": 279,
        "DRA": 80,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 293,
        "Lexile": 1870,
        "DIBELS_gr1": 265,
        "DIBELS_gr2": 281,
        "DIBELS_gr3": 279,
        "DRA": 80,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 294,
        "Lexile": 1880,
        "DIBELS_gr1": 266,
        "DIBELS_gr2": 282,
        "DIBELS_gr3": 281,
        "DRA": 80,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 295,
        "Lexile": 1885,
        "DIBELS_gr1": 267,
        "DIBELS_gr2": 283,
        "DIBELS_gr3": 282,
        "DRA": 80,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 296,
        "Lexile": 1890,
        "DIBELS_gr1": 267,
        "DIBELS_gr2": 284,
        "DIBELS_gr3": 282,
        "DRA": 80,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 297,
        "Lexile": 1900,
        "DIBELS_gr1": 269,
        "DIBELS_gr2": 285,
        "DIBELS_gr3": 284,
        "DRA": 80,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 298,
        "Lexile": 1905,
        "DIBELS_gr1": 269,
        "DIBELS_gr2": 286,
        "DIBELS_gr3": 284,
        "DRA": 80,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 299,
        "Lexile": 1915,
        "DIBELS_gr1": 270,
        "DIBELS_gr2": 287,
        "DIBELS_gr3": 286,
        "DRA": 80,
        "Guided_Reading_Level": "Z"
    },
    {
        "WCPM": 300,
        "Lexile": 1920,
        "DIBELS_gr1": 271,
        "DIBELS_gr2": 288,
        "DIBELS_gr3": 286,
        "DRA": 80,
        "Guided_Reading_Level": "Z"
    }
]
export default { wcpmLookupTable };